/* ============================================================
   LIGE DESIGN
   MODERN EDITORIAL DESCRIPTION
   ============================================================ */

(() => {

  "use strict";


  /* ==========================================================
     SELETORES
     ========================================================== */

  const SELECTORS = {

    root:
      "[data-lige-editorial]",

    reveal:
      "[data-lige-reveal]",

    faq:
      "[data-lige-faq]"

  };


  /* ==========================================================
     ESTADO
     ========================================================== */

  const initializedRoots =
    new WeakSet();


  const reduceMotion =
    window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );


  /* ==========================================================
     REVEAL
     ========================================================== */

  const initializeReveal = (
    root
  ) => {


    const elements =
      Array.from(
        root.querySelectorAll(
          SELECTORS.reveal
        )
      );


    if (
      !elements.length
    ) {

      return;

    }


    if (
      reduceMotion.matches ||
      typeof IntersectionObserver ===
      "undefined"
    ) {


      elements.forEach(
        (element) => {


          element.classList.add(
            "is-visible"
          );


        }
      );


      return;

    }


    const observer =
      new IntersectionObserver(
        (entries) => {


          entries.forEach(
            (entry) => {


              if (
                !entry.isIntersecting
              ) {

                return;

              }


              entry.target.classList.add(
                "is-visible"
              );


              observer.unobserve(
                entry.target
              );


            }
          );


        },
        {

          root: null,

          threshold: 0.10,

          rootMargin:
            "0px 0px -5% 0px"

        }
      );


    elements.forEach(
      (element) => {


        observer.observe(
          element
        );


      }
    );

  };


  /* ==========================================================
     FAQ
     ========================================================== */

  const initializeFaq = (
    root
  ) => {


    const items =
      Array.from(
        root.querySelectorAll(
          SELECTORS.faq
        )
      );


    if (
      !items.length
    ) {

      return;

    }


    items.forEach(
      (item) => {


        item.addEventListener(
          "toggle",
          () => {


            if (
              !item.open
            ) {

              return;

            }


            items.forEach(
              (otherItem) => {


                if (
                  otherItem === item
                ) {

                  return;

                }


                if (
                  otherItem.open
                ) {


                  otherItem.open =
                    false;


                }


              }
            );


          }
        );


      }
    );

  };


  /* ==========================================================
     IMAGENS
     ========================================================== */

  const initializeImages = (
    root
  ) => {


    const images =
      root.querySelectorAll(
        "img"
      );


    images.forEach(
      (image) => {


        if (
          image.complete
        ) {


          image.classList.add(
            "is-loaded"
          );


          return;

        }


        image.addEventListener(
          "load",
          () => {


            image.classList.add(
              "is-loaded"
            );


          },
          {
            once: true
          }
        );


      }
    );

  };


  /* ==========================================================
     ROOT
     ========================================================== */

  const initializeRoot = (
    root
  ) => {


    if (
      initializedRoots.has(
        root
      )
    ) {

      return;

    }


    initializedRoots.add(
      root
    );


    root.classList.add(
      "lige-editorial--initialized"
    );


    initializeReveal(
      root
    );


    initializeFaq(
      root
    );


    initializeImages(
      root
    );

  };


  /* ==========================================================
     INITIALIZE
     ========================================================== */

  const initialize = (
    context = document
  ) => {


    if (
      context.matches &&
      context.matches(
        SELECTORS.root
      )
    ) {


      initializeRoot(
        context
      );

    }


    if (
      !context.querySelectorAll
    ) {

      return;

    }


    const roots =
      context.querySelectorAll(
        SELECTORS.root
      );


    roots.forEach(
      (root) => {


        initializeRoot(
          root
        );


      }
    );

  };


  /* ==========================================================
     START
     ========================================================== */

  const start = () => {


    initialize(
      document
    );


  };


  if (
    document.readyState ===
    "loading"
  ) {


    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );


  } else {


    start();


  }


  /* ==========================================================
     SHOPIFY THEME EDITOR
     ========================================================== */

  document.addEventListener(
    "shopify:section:load",
    (event) => {


      initialize(
        event.target
      );


    }
  );


})();